import React, { useState } from 'react';
import { connect } from 'react-redux';
import { fetchSupplierScorecardsList } from '../../thunks/supplier_scorecards_thunks';
import { useSupplierPerformanceData } from './useSupplierPerformanceData';
import { useSupplierPerformancePresentation } from './useSupplierPerformancePresentation';
import SupplierPerformanceTab from './SupplierPerformanceTab';
import '../charts/chartTheme';
import '../life_cycle_analytics_overview_page/registerTopPerformerShape';

const KPIAnalyticsOverviewSupplierPerformancePage = (props) => {
	const [hoveredSupplierId, setHoveredSupplierId] = useState(null);
	const data = useSupplierPerformanceData(props);
	const presentation = useSupplierPerformancePresentation(data, hoveredSupplierId);
	return (
		<SupplierPerformanceTab
			{...presentation}
			hoveredSupplierId={hoveredSupplierId}
			onHoverSupplier={setHoveredSupplierId}
		/>
	);
};

const mapStateToProps = (state) => ({
	userType: (state as any).session.userType,
	currentUser: (state as any).session.currentUser,
	companyConfig: state.company_config,
});

const mapDispatchToProps = (dispatch) => ({ dispatch });

const mergeProps = (stateProps, dispatchProps, ownProps) => {
	const { userType } = stateProps;
	return {
		...ownProps,
		...stateProps,
		fetchSupplierPerformance: (params, filters = null) =>
			fetchSupplierScorecardsList(userType)(filters || {}),
	};
};

export default connect(
	mapStateToProps,
	mapDispatchToProps,
	mergeProps
)(KPIAnalyticsOverviewSupplierPerformancePage);
